module.exports = __webpack_public_path__ + "./img/favicon/homework/apple-touch-icon.png";